import { BackButton, NextButton } from '@/components/buttons/Buttons';
import Container, { Column } from '@/components/container/Container';
import Spacing from '@/components/container/Spacing';
import { TextBodyMedium, TextHeadlineLarge } from '@/components/text/Texts';
import { NEXT } from '@/constants/button-labels';
import { ESTIMATED_BUDGET } from '@/constants/estimated-budget';
import { FREQUENCY } from '@/constants/frequency';
import type { BudgetEstimatesFields } from '@/types';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import '../../../../components/form-inputs/form-input.styles.css';
import { estimatedBudgetModel } from '../../engine/onboarding.model';
import { OnBoardingStateProgramProps } from '../ChooseProgramWizard';
import { InputController } from '@/components/inputs/InputController';
import DropdownInput from '@/components/inputs/DropdownInput';

const EstimatedBudgetAllocationForm = (props: OnBoardingStateProgramProps) => {
	const form = useForm<BudgetEstimatesFields>({
		defaultValues: {
			estimatedBudget: '',
			estimatedFrequency: '',
		},
		mode: 'all',
		resolver: yupResolver(estimatedBudgetModel),
	});
	//console.log('isValid', isValid);

	// useEffect(() => {
	// 	const subscription = watch((value) => {
	// 		console.log('form values changed:', value);
	// 	});
	// 	return () => subscription.unsubscribe();
	// }, [watch]);
	useEffect(() => {
		if (props.isLoading || !props.onboardingProgram) return;

		if (props.onboardingProgram.EstimatedBudget) {
			form.setValue('estimatedBudget', props.onboardingProgram.EstimatedBudget, {
				shouldValidate: true,
			});
		}

		if (props.onboardingProgram.EstimatedFrequency) {
			form.setValue('estimatedFrequency', props.onboardingProgram.EstimatedFrequency, {
				shouldValidate: true,
			});
		}
	}, [props.isLoading, props.onboardingProgram, form]);

	const onNext = (data: BudgetEstimatesFields) => {

		props.onSubmit({ EstimatedBudget: data.estimatedBudget, EstimatedFrequency: data.estimatedFrequency });
	};

	return (
		<Container className='w-[732px] max-w-full tablet:w-full'>
			<TextHeadlineLarge
				text="What is the estimated budget allocated for these services"
				className="text-neutral17"
			/>
			<Spacing height="h-[8px]" />
			<TextBodyMedium
				text="Understanding the financial resources allocated for these services helps us tailor our offerings to meet your specific needs and preferences."
				className="text-neutral17"
			/>
			<Spacing height="h-[62px]" />
			<Container >
				<Column>
					<InputController id="estimatedBudget" control={form.control}>
						<DropdownInput
							options={ESTIMATED_BUDGET}
							label="Estimated Budget"
							placeholder="Please select"
						/>
					</InputController>
					<Spacing height="h-4" />
					<InputController id="estimatedFrequency" control={form.control}>
						<DropdownInput
							options={FREQUENCY}
							label="Frequency"
							placeholder="Please select"
						/>
					</InputController>
				</Column>
			</Container>
			<Spacing height="h-[40px]" />
			<Container className="flex justify-between">
				{props.onBack ? (
					<BackButton
						withIcon={true}
						onClick={props.onBack}
						id="choose-program-back"
					/>
				) : (
					''
				)}
				<Container className="flex self-end justify-self-end">
					<NextButton
						withIcon={false}
						label={NEXT}
						disabled={!form.formState.isValid}
						onClick={form.handleSubmit(onNext)}
						id="choose-program-next"
					/>
				</Container>
			</Container>
		</Container>
	);
};

export default EstimatedBudgetAllocationForm;
